import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 作成日時
 */
export class CreateDatetime extends PrimitiveValueObjectDateTime {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: Date): CreateDatetime {
    return new CreateDatetime(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '作成日時';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${d.getHours()}時${d.getMinutes()}分`;
  }
}
